<div
  class="detail-content"
  #rightSide
>
  <!-- DETAIL FOR PUBBLICAZIONE -->
  <div aria-label="Anteprima della pubblicazione">
    <div
      *ngIf="pubElement.oggetto"
      class="div-info-doc"
      attr.aria-label="pubblicazione oggetto {{ pubElement.oggetto }}"
    >
      <strong [innerHTML]="pubElement.oggetto">{{ pubElement.oggetto }}</strong>
      <div>
        <p-button
          icon="pi pi-times"
          (onClick)="closeRightPanel.emit()"
        ></p-button>
      </div>
    </div>
    <div
      *ngIf="!pubElement.oggetto"
      class="div-info-doc"
    >
      <strong>[Oggetto non assegnato]</strong>
    </div>
    <p-accordion
      [multiple]="true"
      #accordionDetail
    >
      <p-accordionTab
        header="Dettagli pubblicazione"
        aria-controls="sect1"
      >
        <div
          *ngIf="pubElement"
          id="sect1"
        >
          <ng-template
            ngFor
            let-row
            [ngForOf]="fieldsToUse"
          >
            <div
              *ngIf="pubElement[row.field] !== null && row.type == 'header'"
              class="general-field"
            >
              <h3>{{ row.header }}{{ pubElement[row.field] }}</h3>
            </div>
            <div
              *ngIf="pubElement['provvedimento'] && pubElement['provvedimento'][row.field] !== null && row.type == 'string'"
              class="general-field"
            >
              <label>{{ row.header }}</label>
              <div>{{ pubElement["provvedimento"][row.field] }}</div>
            </div>
            <div
              *ngIf="
                pubElement['provvedimento'] &&
                pubElement['provvedimento'][row.field] === null &&
                row.field === 'noteGenerali' &&
                row.type == 'string'
              "
              class="general-field"
            >
              <label>{{ row.header }}</label>
              <div *ngIf="pubElement['provvedimento'][row.field] !== null; else elseBlock">
                {{ pubElement["provvedimento"][row.field] }}
              </div>
              <ng-template #elseBlock>
                <div>Non presenti</div>
              </ng-template>
            </div>
            <div
              *ngIf="
                pubElement?.pubblicazioneCommittente &&
                pubElement.pubblicazioneCommittente[row.field] !== null &&
                row.type == 'string'
              "
              class="general-field"
            >
              <label>{{ row.header }}</label>
              <div>{{ pubElement.pubblicazioneCommittente[row.field] }}</div>
            </div>
            <div
              *ngIf="
                pubElement?.pubblicazioneCommittente &&
                pubElement.pubblicazioneCommittente[row.field] !== null &&
                row.type == 'date'
              "
              class="general-field"
            >
              <label>{{ row.header }}</label>
              <div>{{ pubElement.pubblicazioneCommittente[row.field] | date: "dd/MM/yyyy" }}</div>
            </div>
            <div
              *ngIf="
                pubElement?.pubblicazioneCommittente &&
                pubElement.pubblicazioneCommittente[row.field] !== null &&
                row.type == 'boolean'
              "
              class="general-field"
            >
              <label>{{ row.header }}</label>
              <div *ngIf="pubElement.pubblicazioneCommittente[row.field]; else elseBlock">Si</div>
              <ng-template #elseBlock>
                <div>Non richiesto</div>
              </ng-template>
            </div>
            <div
              *ngIf="pubElement[row.field] !== null && row.type == 'string-1'"
              class="general-field"
            >
              <label>{{ row.header }}</label>
              <div>{{ pubElement[row.field] }}</div>
            </div>
            <div
              *ngIf="pubElement[row.field] !== null && row.type == 'date-1'"
              class="general-field"
            >
              <label>{{ row.header }}</label>
              <div>{{ pubElement[row.field] | date: "dd/MM/yyyy" }}</div>
            </div>
            <div
              *ngIf="pubElement[row.field] !== null && row.type == 'date-2'"
              class="general-field"
            >
              <label>{{ row.header }}</label>
              <div>
                Dal: {{ pubElement[row.field] | date: "dd/MM/yyyy" }} Al: {{ pubElement[row.field2] | date: "dd/MM/yyyy" }}
              </div>
            </div>
            <div
              *ngIf="pubElement[row.field] !== null && row.type == 'dontKnow'"
              class="general-field"
            >
              <label>{{ row.header }}</label>
              <div></div>
            </div>
          </ng-template>
        </div>
        <div *ngIf="!pubElement">Non sono presenti dettagli da visualizzare.</div>
      </p-accordionTab>
      <!-- <p-accordionTab header="Allegati" aria-controls="sect2">
        <div *ngIf="pubElement.allegatiList" id="sect2">
          <ul style="padding:; margin: ;">
            <li *ngFor="let allegati of pubElement.allegatiList" class="allegati-li">
              {{allegati.codice}} 
               <p-button
                  styleClass="p-button-sm"
                  title="Scarica Allegati"
                  icon="pi pi-download" 
                  (onClick)="downloadAllegati(allegati)">
                </p-button>
            </li>
          </ul>
        </div>
        <div *ngIf="!pubElement" class="text-centered">
            Non sono presenti allegati da visualizzare.
        </div>
    </p-accordionTab> -->
    </p-accordion>
    <div class="allegati-dropdown">
      <p-select
        #allegatiDropDown
        [(ngModel)]="allegatoSelezionato"
        [options]="pubElement.allegatiList"
        optionLabel="nomeAllegato"
        (onChange)="allegatoSelected($event)"
      >
      </p-select>
      <img
        *ngIf="!noAnteprima && !rowChanged"
        src="assets/images/fullscreen-symbol.svg"
        (click)="fullscreen($event)"
        alt="fullscreen"
      />
    </div>
  </div>
  <div class="d-flex flex-grow-1">
    <div class="preview-inner">
      <iframe
        *ngIf="!noAnteprima && !rowChanged"
        #anteprima
        id="anteprima"
        frameborder="0"
        allowfullscreen
        webkitallowfullscreen
        mozallowfullscreen
      >
      </iframe>
      <div
        *ngIf="noAnteprima"
        class="no-anteprima"
      >
        L'anteprima non è disponibile per questo tipo di attività.
      </div>
    </div>
  </div>
</div>
